///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ErrorHandler, Injectable } from '@angular/core';
import { GtthLogSenderService } from './backend-logging/logs-sender.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class GtthErrorHandler extends ErrorHandler {
    constructor(private readonly logSender: GtthLogSenderService) {
        super();
    }

    handleError(error: Error | HttpErrorResponse) {
        console.error(`${error.name} `, error);

        if (error instanceof HttpErrorResponse) {
            if (error.status < 400) {
                this.logSender.logError(`${error.name}: ${error.message}`);
            }
        } else {
            this.logSender.logError(`${error.name}: ${error.message} ` + JSON.stringify(error.stack));
        }
    }
}
